module.exports = __webpack_public_path__ + "static/img/pay-code.182fc3a8.png";